export class PlanningResourcesDataMappingToolService {
	constructor($resource, ApiService) {
		'ngInject';

		this.$resource = $resource;
		this.apiService = ApiService;

		this.dataMappingToolResourceUrl = this.apiService.getResourceUrl('menus/DataMappingTool');

		this.dataMappingToolResource = this.$resource(this.dataMappingToolResourceUrl);
	}

	_getOverviewDetailsObject(details) {
		return {
			contentId: details.content_id,
			menuId: details.menu_id,
			displayName: details.display_name,
			name: details.name,
			title: details.title,
			image: details.image || '',
			description: details.description
		}
	}

	_getChildrenObject(details) {
		return details.map(value => this._getOverviewDetailsObject(value));
	}

	/**
	 * function to get about us content
	 * @return {object} [information related to data mapping tool]
	 */
	getDataMappingToolDetails() {
		const promise = this.dataMappingToolResource.get().$promise;

		return promise.then(details => ({
			menuOverviewDetails: this._getOverviewDetailsObject(details.data.menuOverviewDetails),
			children: this._getChildrenObject(details.data.children)
		})).catch((error) => {
			throw this.apiService.getErrorMessage(error);
		});
	}
}


// WEBPACK FOOTER //
// ./src/app/components/planning-resources-data-mapping-tool/planning-resources-data-mapping-tool.service.js